import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { Factory, Shield, FileText, Mail } from "lucide-react";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="bg-brand-navy text-slate-300 mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-9 h-9 rounded-md bg-white/5 flex items-center justify-center">
              <Factory className="w-5 h-5 text-brand-amber" />
            </div>
            <div>
              <div className="text-lg font-bold text-white">{t("brand")}</div>
              <div className="text-[11px] text-slate-400">MERQAV</div>
            </div>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">{t("slogan")}</p>
          <p className="text-xs text-slate-500 leading-relaxed mt-2">Connecting Industry. Building Trust.</p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm">الخدمات</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/capabilities" className="hover:text-white">القدرات التصنيعية</Link></li>
            <li><Link to="/industries" className="hover:text-white">القطاعات المخدومة</Link></li>
            <li><Link to="/register" className="hover:text-white">اطلب تصنيع قطعة</Link></li>
            <li><Link to="/register?role=workshop" className="hover:text-white">انضم كشريك تصنيع</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm">المنصة</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white">من نحن</Link></li>
            <li><Link to="/faq" className="hover:text-white">الأسئلة الشائعة</Link></li>
            <li><Link to="/contact" className="hover:text-white">تواصل معنا</Link></li>
            <li><Link to="/how-it-works" className="hover:text-white">كيف تعمل MERQAV</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm">الالتزامات</h4>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2"><Shield className="w-4 h-4 text-brand-amber" /> سرية الملفات الفنية</li>
            <li className="flex items-center gap-2"><FileText className="w-4 h-4 text-brand-amber" /> الشروط والأحكام</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-brand-amber" /> info@merqav.sa</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-4 text-xs text-slate-400 flex flex-wrap justify-between gap-2">
          <div>© {new Date().getFullYear()} MERQAV — MERQAV. جميع الحقوق محفوظة.</div>
          <div className="flex gap-4">
            <Link to="/terms" className="hover:text-white">الشروط</Link>
            <Link to="/privacy" className="hover:text-white">الخصوصية</Link>
            <Link to="/confidentiality" className="hover:text-white">سياسة السرية</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
